import { apiV1 } from './api';

const getAnalysis = (quoteVersionId, config = {}) =>
  apiV1.get(`/quote_versions/${quoteVersionId}/ai_analysis`, config).then(({ data }) => data);

const retryAnalysis = quoteVersionId =>
  apiV1.post(`/quote_versions/${quoteVersionId}/ai_analysis/retry`).then(({ data }) => data);

const updateAnalysis = (quoteVersionId, analysis) =>
  apiV1.patch(`/quote_versions/${quoteVersionId}/ai_analysis`, { quoteAiAnalysis: analysis }).then(({ data }) => data);

const confirmAnalysis = quoteVersionId =>
  apiV1.post(`/quote_versions/${quoteVersionId}/ai_analysis/confirm`).then(({ data }) => data);

export const aiAnalysisAPI = { getAnalysis, retryAnalysis, updateAnalysis, confirmAnalysis };
